<ListItem accordionItem title={option.label || option.key}>
  <AccordionContent>
    <List noHairlinesMd>
      <ListInput
        type="colorpicker"
        label="Background Color"
        placeholder="(transparent)"
        clearButton
        value={(value && value.color)? { hex: value.color } : {}}
        on:change={(e) => handleInputChange('color', e)}
      />
    </List>
  </AccordionContent>
</ListItem>

<style>
  *, *::before, *::after {
    box-sizing: border-box;
  }</style>

<script lang="ts">import { List, ListInput, ListItem, AccordionContent } from 'framework7-svelte';
import './CardsEditorComponentInterfaces';
import './context';
import { createEventDispatcher } from 'svelte';
import 'yinzcam-cards';
export let option;
export let value = {};
const dispatch = createEventDispatcher();
// const initialValue?
function handleInputChange(key, e) {
    var _a;
    //console.log("handleChange", key, e);
    let input = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a[0].target;
    if (input) {
        value[key] = input.value;
        dispatch('change', { value });
    }
}
</script>